import { zipObject, get } from 'lodash';
import { Middleware } from 'redux';
import AndroidAdapter from './AndroidAdapter';
import IOSAdapter from './IOSAdapter';
import { AppAdapter } from './AppAdapter';
import { StoreType } from '../../store';
import { fccFlows } from '../../../modularReduxComponents/App/constants';

let adapter: AppAdapter | null;

declare global {
  interface Window {
    Cypress: any;
    appAdapter: any;
  }
}

const adapterFactory = (appOs: string): AppAdapter | null => {
  // We need to expose this for e2e tests
  if (appOs && window.Cypress) {
    window.appAdapter = adapter;
  }

  switch (appOs) {
    case 'ios':
      return new IOSAdapter();
    case 'android':
      return new AndroidAdapter();
    default:
      return null;
  }
};

const appBridgeMiddleware: Middleware<Record<string, never>, StoreType> =
  store => next => action => {
    const appOs =
      get(store.getState(), 'app.appOs', null) ||
      get(action, 'payload.appOs', null);
    const error = get(action, 'payload.error', undefined);

    switch (action.type) {
      case 'initializeInApp':
        adapter = adapterFactory(appOs);
        break;
      case 'appInitializeSuccess':
        if (adapter && fccFlows.indexOf(action.payload.flowId) !== -1) {
          adapter.linkToExternalBrowser();
        }
        break;
      case 'postRegComplete':
        if (adapter) {
          adapter.registrationComplete({
            accountType:
              get(store.getState(), 'user.fundingAccounts.accountType') ||
              'ach',
            initialAmount: get(
              store.getState(),
              'app.answers.setInitialFundingAmount', ''
            ),
            needsVerification: get(store.getState(), 'app.needsVerification', false),
            confirmationMessage: get(
              store.getState(),
              'user.registeredUser.confirmationMessage',
              ''
            )
          });
        }
        break;
      case 'registrationFailedAppMode':
        adapter = adapter || adapterFactory(appOs);
        if (adapter) {
          adapter.registrationFailed(error as Error);
        }
        break;
      case 'getUserFailure':
      case 'registrationReauth':
        if (adapter) {
          adapter.registrationReAuth();
        }
        break;
      case 'setInAppUserPropertiesOnAnswer':
        // Handle account creation
        const originalQuestionsAndAnswer: Record<string, string> = zipObject(
          action.payload.questions,
          action.payload.answers
        );
        if (adapter) {
          adapter.setUserInfo({
            email: get(originalQuestionsAndAnswer, 'set_user_email') as string,
            password:
              get(originalQuestionsAndAnswer, 'set_user_password') ||
              (get(
                originalQuestionsAndAnswer,
                'set_user_password_and_confirm'
              ) as string),
            jwt: action.payload.token as string
          });
        }
        break;
      case 'launchNativePlaidFlow':
        if (adapter) {
          adapter.launchNativePlaidFlow();
        }
        break;
      case 'failedWriaUrlValidation':
        console.log('Failed WRIA URL validation');
        if (adapter) {
          adapter.linkToExternalBrowser();
        }
      default:
        break;
    }
    next(action);
  };

export default appBridgeMiddleware;
